import { render, staticRenderFns } from "./DetailsReader.vue?vue&type=template&id=2ce6480e&"
import script from "./DetailsReader.vue?vue&type=script&lang=js&"
export * from "./DetailsReader.vue?vue&type=script&lang=js&"
import style0 from "./DetailsReader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports